import USER_SELECTED_PROMPT_SETTING from './user-selected-prompt-setting.type';
import createStandardAction from '../../utilities/create-standard-action';

const userSelectedPromptSetting = createStandardAction(
  USER_SELECTED_PROMPT_SETTING
);

export default userSelectedPromptSetting;
